export const computeTokens = ({commit, rootGetters, state}) => {
  return new Promise(() => {
    if (state.search.trim() === '') {
      commit('setTokens', {tokens: []})
    }
    const lastToken = state.search.split(' ').pop().toLocaleLowerCase()
    const items = rootGetters['destiny/items']
    const tokens = Object.entries(items
      .map(i => i.tokens)
      .reduce((a, b) => [...a, ...b], [])
      .concat(items.map(i => i.name.toLowerCase()))
      .filter(token => token.indexOf(lastToken) !== -1)
      .filter(token => state.search.indexOf(token) === -1)
      .reduce((acc, v) => {
        acc[v] = (acc[v] || 0) + 1
        return acc
      }, {}))
      .sort((a, b) => a[1] < b[1] ? 1 : -1).slice(0, 20)
    commit('setTokens', {tokens})
  })
}



// WEBPACK FOOTER //
// ./src/store/destiny/filters/actions.js